import React from 'react';

// The Unit and Standards headings inside the filter panel: both h3, under the panel's "Filters" h2.
// _global.scss gives h1/h2 the very-dark-grey colour and a 5px bottom padding but gives h3 only a
// 1.3em top margin, so the utilities keep the h3 looking exactly like the h2 it replaced. The hover
// colour stays: Collapse puts an onClick on the row, so clicking the heading toggles the section.
const SectionHeading = ({ children }: { children: React.ReactNode }) => (
  <h3 className="tw-px-4 tw-my-0 tw-pb-[5px] tw-text-very-dark-grey hover:tw-text-tci-purple body bold">
    {children}
  </h3>
);

export default SectionHeading;
